import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.254 4.867a.47.47 0 0 1 .102-.511l2.812-2.813a.47.47 0 0 1 .664 0l2.812 2.813a.468.468 0 0 1-.332.8H4.687a.47.47 0 0 1-.433-.29m6.058 4.977H4.687a.469.469 0 0 0-.331.8l2.812 2.813a.47.47 0 0 0 .664 0l2.812-2.813a.468.468 0 0 0-.332-.8" }, null, -1)
  ]))]))
}
export default { render: render }